// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__yEdTp","validationTips":"StatementDescriptor_validationTips__l_dV9"};